import { getFlag } from "@/config/rdoFlags";
import { AttachmentsModule } from "@/components/rdo/modules/AttachmentsModule";
import { LegacyAttachmentsSection } from "@/components/rdo/legacy/LegacyAttachmentsSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

export function AttachmentsForRDO({
  legacyValue,
  onLegacyChange,
  mode,
  // Legacy props for compatibility
  showAttachmentModal,
  setShowAttachmentModal,
  handleDeleteAttachment,
  isEditing,
  isSectionEnabled,
}: {
  legacyValue: any;                 // shape atual usado em RDO.tsx (anexos)
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
  // Legacy props
  showAttachmentModal?: boolean;
  setShowAttachmentModal?: (show: boolean) => void;
  handleDeleteAttachment?: (index: number) => void;
  isEditing?: boolean;
  isSectionEnabled?: (section: string) => boolean;
}) {
  if (!getFlag("useNewAttachmentsInRDO")) {
    // Render legado de Anexos (manter como está)
    return (
      <LegacyAttachmentsSection 
        value={legacyValue} 
        onChange={onLegacyChange} 
        mode={mode}
        showAttachmentModal={showAttachmentModal}
        setShowAttachmentModal={setShowAttachmentModal}
        handleDeleteAttachment={handleDeleteAttachment}
        isEditing={isEditing}
        isSectionEnabled={isSectionEnabled}
      />
    );
  }

  // 1) Converte do legado -> RDO (somente attachments)
  const mockRDO = {
    id: "",
    obraId: "",
    date: "",
    status: "draft" as const,
    workforce: [],
    equipment: [],
    activities: [],
    occurrences: [],
    materials: { received: [], used: [] },
    comments: [],
    photos: [],
    videos: [],
    attachments: legacyValue || [],
    createdAt: "",
    updatedAt: "",
  };
  
  const rdo: RDO = normalizeFromRDOPAGE(mockRDO);

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <AttachmentsModule
      value={rdo.attachments}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(attachments) => {
        // 3) Converte de volta p/ o payload legado
        const payload = toRDOPAGEPayload({ ...rdo, attachments });
        onLegacyChange(payload.attachments);
      }}
    />
  );
}